import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { createXFinanzDateiSaga } from "./sagas/createXFinanzDateiSaga";
import { deleteXFinanzDateiSaga } from "./sagas/deleteXFinanzDateiSaga";

const xFinanzDateiModule = (): Module => ({
	id: "xFinanzDatei",
	sagas: () => [createXFinanzDateiSaga, deleteXFinanzDateiSaga]
});

export default xFinanzDateiModule;
